import {dedupingMixin} from "@polymer/polymer/lib/utils/mixin";

/**
 * @polymer
 * @mixinFunction
 **/
export const CanvasDraggableBehavior = dedupingMixin((superClass) => class extends superClass {
  static get properties() {
    return {
      _canvasDraggableMouseWasDragged: {type: Boolean},
      _canvasDraggableDraggingShape: {type: Object},
      _canvasDraggableStartPosition: {type: Object},
      canvasDraggableContainer: {type: Object, observer: 'canvasDraggableContainerChanged'},
      canvasDraggableElement: {type: Object},
      canvasDraggableShapes: {type: Array},
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this._boundDraggableMouseDown = this.canvasDraggableHandleMouseDown.bind(this);
    this._boundDraggableMouseMove = this.canvasDraggableHandleMouseMove.bind(this);
    this._boundDraggableMouseUp = this.canvasDraggableHandleMouseUp.bind(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.canvasDraggableContainer = null;
    this.canvasDraggableElement = null;
    this.canvasDraggableShapes = null;
  }

  canvasDraggableFindShapeAtCursor(mousePosition) {
    if (this.canvasDraggableShapes?.length) {
      for (const {shape, screen} of this.canvasDraggableShapes) {
        if (mousePosition.x >= screen.x && mousePosition.x <= (screen.x + screen.width) && mousePosition.y >= screen.y && mousePosition.y <= screen.y + screen.height) {
          return {
            shape,
            screen,
            offsetX: mousePosition.x - screen.x,
            offsetY: mousePosition.y - screen.y
          };
        }
      }
    }
  }

  canvasDraggableContainerChanged(newValue, oldValue) {
    if (newValue) {
      newValue.addEventListener('mousedown', this._boundDraggableMouseDown);
      newValue.addEventListener('mousemove', this._boundDraggableMouseMove);
      newValue.addEventListener('mouseup', this._boundDraggableMouseUp);
    }
    if (oldValue) {
      oldValue.removeEventListener('mousedown', this._boundDraggableMouseDown);
      oldValue.removeEventListener('mousemove', this._boundDraggableMouseMove);
      oldValue.removeEventListener('mouseup', this._boundDraggableMouseUp);
    }
  }

  canvasDraggableGetMousePosition(event, canvas) {
    if (!canvas) {
      return;
    }
    const bounds = (canvas).getBoundingClientRect();
    return {x: event.clientX - bounds.left, y: event.clientY - bounds.top};
  }

  canvasDraggableHandleMouseDown(event) {
    if (event.button !== 0) {
      return;
    }

    const mousePosition = this.canvasDraggableGetMousePosition(event, this.canvasDraggableElement)

    const shape = this.canvasDraggableFindShapeAtCursor(mousePosition);
    if (!shape) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this._canvasDraggableStartPosition = mousePosition;
    this._canvasDraggableDraggingShape = shape;
  }

  canvasDraggableHandleMouseMove(event) {
    if (!this._canvasDraggableDraggingShape) {
      return;
    }

    this._canvasDraggableMouseWasDragged = true;

    event.preventDefault();
    event.stopImmediatePropagation();

    const position = this.canvasDraggableGetMousePosition(event, this.canvasDraggableElement);
    this.handleCanvasDraggableMove(event, {
      shape: this._canvasDraggableDraggingShape.shape,
      x: position.x - this._canvasDraggableDraggingShape.offsetX,
      y: position.y - this._canvasDraggableDraggingShape.offsetY,
      width: this._canvasDraggableDraggingShape.screen.width,
      height: this._canvasDraggableDraggingShape.screen.height
    });
  }

  canvasDraggableHandleMouseUp(event) {
    if (!this._canvasDraggableDraggingShape) {
      return;
    }

    if (this._canvasDraggableMouseWasDragged) {
      const position = this.canvasDraggableGetMousePosition(event, this.canvasDraggableElement);
      this.handleCanvasDraggableFinished(event, {
        shape: this._canvasDraggableDraggingShape.shape,
        x: position.x - this._canvasDraggableDraggingShape.offsetX,
        y: position.y - this._canvasDraggableDraggingShape.offsetY,
        width: this._canvasDraggableDraggingShape.screen.width,
        height: this._canvasDraggableDraggingShape.screen.height
      });
    }

    this._canvasDraggableStartPosition = null;
    this._canvasDraggableDraggingShape = null;
    this._canvasDraggableMouseWasDragged = false;
  }

  /**
   * Must be implemented on the parent component.
   */
  handleCanvasDraggableMove() {
    console.warn('%cCanvas Draggable Behavior:', 'background: #fc0; color: #000', 'Method `handleCanvasDraggableMove` not defined.');
  }

  /**
   * Must be implemented on the parent component.
   */
  handleCanvasDraggableFinished() {
    console.warn('%cCanvas Draggable Behavior:', 'background: #fc0; color: #000', 'Method `handleCanvasDraggableFinished` not defined.');
  }
});